import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import { et3ReadableDecimalNumber } from "../../helpers/et3-data-helper";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import Et3Margin from "../../core/et3-ui/ET3Margin";
import React from "react";
import getDashBoardStore from "../../stores/dashboard-store";

const AdminSalary = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const isKhattabaAdmin = getCorePersonalStore().isManualKhattabaAdmin.get();
  const adminSalary = getDashBoardStore().khattabatAdminRemuneration.get();
  const roundedSalary = `${et3ReadableDecimalNumber(adminSalary, 2)}`;

  return !isKhattabaAdmin ? null : (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={300}
        height={30}
        fDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => { }}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={40}
          text={`${roundedSalary} $`}
          isSpan={false}
          color={colors.all.white}
          style={{}}
        />
      </ET3Div>
      <Et3Margin top={0} left={0} right={0} bottom={30} />
    </React.Fragment>
  );
});
export default AdminSalary;
